/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_TitleInputs */

const en_landing_drift_title = /** @type {(inputs: Landing_Drift_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One image, three edits. Watch what stays.`)
};

const zh_landing_drift_title = /** @type {(inputs: Landing_Drift_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一张图，三轮编辑，看看什么没变。`)
};

/**
* | output |
* | --- |
* | "One image, three edits. Watch what stays." |
*
* @param {Landing_Drift_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_title = /** @type {((inputs?: Landing_Drift_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_title(inputs)
	return zh_landing_drift_title(inputs)
});
export { landing_drift_title as "landing.drift.title" }